import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SuccessDialog } from 'components/Shared/Dialogs/SuccessDialog'
import { triggerFormSubmit } from 'utils/utils'
import { TitleBar } from 'components/Shared/CrudComponents/TitleBar'
import { HTTP_404_ERROR, HTTP_422_ERROR } from 'Constants'
import ApiError from 'constants/ApiError'
import { useErrorHandling } from 'context/errorHandling'
import { ContractorFormFields, ContractorSchema } from 'components/Contractors/ContractorFormFields'
import { createContractor } from 'services/ContractorService'
import { FormikForm } from 'components/Shared/FormikForm'
import ContractorRole from 'constants/ContractorRole'
import { useNavigatePrevent } from 'context/navigatePrevent'
import Module from 'constants/customFieldModules'

export const initialValues = {
  fullName: '',
  shortName: '',
  companyAddress: {
    street: '',
    cityName: '',
    country: '',
    zipCode: ''
  },
  correspondenceAddress: {
    street: '',
    cityName: '',
    country: '',
    zipCode: ''
  },
  phoneNumber: '',
  nipNumber: '',
  regonNumber: undefined,
  krsNumber: undefined,
  contactEmail: '',
  accountingEmail: undefined,
  eInvoiceConsent: false,
  isPartnershipSubsidiary: false,
  incomePaymentDueDays: 60,
  costPaymentDueDays: 60,
  debtLimit: 0,
  currency: "PLN",
  additionalInfo: undefined,
  filesIds: [],
  roles: [ContractorRole.CARRIER, ContractorRole.CLIENT]
}

export function CreateContractorForm () {
  const [createdDialogOpen, setCreatedDialogOpen] = useState(false)

  const { t } = useTranslation()
  const { handleError } = useErrorHandling()
  const { setNavigationUnlocked } = useNavigatePrevent()

  const createContractorFormRef = useRef()

  function handleSubmit (values, onSuccess) {
    createContractor(values)
      .then(createdContractor => {
          setCreatedDialogOpen(true)
          return onSuccess(createdContractor.id)
            .catch(handleError)
        }
      )
      .catch(error => {
        const errorCode = error?.response?.data?.errorCode
        handleError(error, {
          [HTTP_404_ERROR]: 'notifications.error.contractorNotFound',
          [HTTP_422_ERROR]: errorCode === 'CONTRACTOR_NIP_CONFLICT' ?
            'notifications.error.contractorNipNumberAlreadyExists' :
            errorCode === 'CONTRACTOR_CONTACT_EMAIL_CONFLICT' ?
              'notifications.error.contractorContactEmailAlreadyExists' : ApiError.UnprocessableEntity
        })
      })
  }

  function handleSuccessDialogClose () {
    setCreatedDialogOpen(false)
    setNavigationUnlocked(history => history.push('/contractors'))
  }

  return <div>
    <TitleBar
      buttonLabel={t('contractor.form.submit')}
      onButtonClick={triggerFormSubmit(createContractorFormRef)}
      title={t('contractor.form.createTitle')}/>
    <SuccessDialog open={createdDialogOpen}
                   onClose={handleSuccessDialogClose} content={'notifications.success.contractorCreated'}/>
    <FormikForm
      innerRef={createContractorFormRef}
      initialValues={initialValues}
      validationSchema={ContractorSchema}
      onSubmit={handleSubmit}
      customFields={{
        module: Module.Contractors
      }}>
        <ContractorFormFields initialFiles={[]}/>
    </FormikForm>
  </div>
}
